import { useContext } from 'react';
import { RemoveAuthItemContext } from '../context';
import { NotWrappedError } from '../functions';
var useRemoveAuthItem = function () {
    var context = useContext(RemoveAuthItemContext);
    if (context === null)
        throw new NotWrappedError();
    return context;
};
export default useRemoveAuthItem;
//# sourceMappingURL=useRemoveAuthItem.js.map